export default "__VITE_ASSET__D6oqK9DL__"